// Contexte audio partagé, débloqué au premier geste de l'utilisateur (règle autoplay des navigateurs)
let ctx = null;
const EVENTS = ["pointerdown", "touchstart", "keydown", "click"];

export const getAlarmCtx = () => {
  const C = window.AudioContext || window.webkitAudioContext;
  if (!C) return null;
  if (!ctx || ctx.state === "closed") ctx = new C();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

export const isAlarmAudioReady = () => !!ctx && ctx.state === "running";

const unlock = () => {
  const c = getAlarmCtx();
  if (!c) return;
  const src = c.createBufferSource();
  src.buffer = c.createBuffer(1, 1, 22050);
  src.connect(c.destination);
  src.start(0);
};

export const installAudioUnlock = () => {
  const handler = () => {
    unlock();
    if (isAlarmAudioReady()) EVENTS.forEach((e) => document.removeEventListener(e, handler, true));
  };
  EVENTS.forEach((e) => document.addEventListener(e, handler, true));
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && ctx) ctx.resume().catch(() => {});
  });
};
